import React from "react";

class MobileOtpToast extends React.Component {
  close = () => {
    const { onClose } = this.props;
    onClose && onClose();
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = 0;
    }
  };

  componentDidMount() {
    this.timer = setTimeout(() => {
      this.close();
    }, this.props.delay);
  }

  componentWillUnmount() {
    this.close();
  }

  render() {
    return (
      <div className="verify-mobile-toast" onClick={this.close}>
        <div className="msg">{this.props.message}</div>
      </div>
    );
  }
}

export default MobileOtpToast;



// WEBPACK FOOTER //
// ./app/components/security/verification/MobileOtpToast.js